import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ConnectivityBanner() {
  const { t } = useTranslation();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const up   = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online',  up);
    window.addEventListener('offline', down);
    return () => { window.removeEventListener('online', up); window.removeEventListener('offline', down); };
  }, []);

  if (online) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'relative', zIndex: 40,
        background: '#1E293B', color: '#fff',
        padding: '8px 16px', display: 'flex', alignItems: 'center', gap: 8,
        fontSize: 13, fontWeight: 600,
      }}
    >
      <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="#FBBF24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 010 12.728M5.636 5.636a9 9 0 000 12.728M12 12h.01M15.536 8.464a5 5 0 010 7.072M8.464 8.464a5 5 0 000 7.072" />
      </svg>
      {t('connectivity.noInternet')}
    </div>
  );
}
